import { render, staticRenderFns } from "./PsGroupsDetailDailyItem.vue?vue&type=template&id=c25aa9fe&scoped=true&"
import script from "./PsGroupsDetailDailyItem.vue?vue&type=script&lang=js&"
export * from "./PsGroupsDetailDailyItem.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsDetailDailyItem.vue?vue&type=style&index=0&id=c25aa9fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25aa9fe",
  null
  
)

export default component.exports